import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { hashHistory } from 'react-router';

import '../css/image-gallery.css';
import '../css/main.css';

export default class PhotoListComponent extends React.Component {

    componentWillMount() {
    }

    componentDidMount() {
    }

    previousPage() {
        let previousPage = '/';
        if (this.props.previousPage) {
            previousPage = this.props.previousPage;
        }
        hashHistory.push(previousPage);
    }

    thumbnails(photos) {
        let ret = [];
        if (photos) {
            return photos;
        }
        return ret;
    }

    render() {

        let code = null;
        if (this.props.card) {
            code = this.props.card.get('code');
        }

        let navigation = null;
        if (this.props.previousPage === '/refineCards') {
            navigation = (
                <span>作業開工確認 &gt;&gt;&nbsp;維修表確認修改 &gt;&gt;&nbsp;</span>
            )
        } else if (this.props.previousPage === '/fixingCards') {
            navigation = (
                <span>維修作業 &gt;&gt;&nbsp;維修卡 &gt;&gt;&nbsp;</span>
            )
        } else if (this.props.previousPage === '/fixingAppend') {
            navigation = (
                <span>維修作業 &gt;&gt;&nbsp;增補項目 &gt;&gt;&nbsp;</span>
            )
        } else if (this.props.previousPage === '/auditingCards') {
            navigation = (
                <span>檢點作業 &gt;&gt;&nbsp;維修卡 &gt;&gt;&nbsp;</span>
            )
        }

        return (
            <div><span hidden> PhotoListComponent </span>
                <Row>
                    <h4>
                        {navigation}
                        相片列表
                    <a onClick={(e) => { this.previousPage() }}><img src="back.png" title="回上一頁" alt="回上一頁" style={{ cursor: 'pointer' }} /></a>
                    </h4>
                </Row>
                <h5 style={{ marginBottom: 20 }}><span className='highlight-B'>{code}</span></h5>
                <h4>清洗維修前</h4>
                <Row>
                    {
                        this.thumbnails(this.props.clothesPrePhotoList).map(
                            (item, index) =>
                                <Col xs={12} sm={6} key={item.get('id')}>
                                    <a href={item.get('image')} target="_blank">
                                        <img src={item.get('image')} className="img-thumbnail" alt="" />
                                    </a>
                                </Col>
                        )
                    }
                </Row>
                <Row>
                    {
                        this.thumbnails(this.props.pantPrePhotoList).map(
                            (item, index) =>
                                <Col xs={12} sm={6} key={item.get('id')}>
                                    <a href={item.get('image')} target="_blank">
                                        <img src={item.get('image')} className="img-thumbnail" alt="" />
                                    </a>
                                </Col>
                        )
                    }
                </Row>
                <h4>清洗維修後</h4>
                <Row>
                    {
                        this.thumbnails(this.props.clothesPostPhotoList).map(
                            (item, index) =>
                                <Col xs={12} sm={6} key={item.get('id')}>
                                    <a href={item.get('image')} target="_blank">
                                        <img src={item.get('image')} className="img-thumbnail" alt="" />
                                    </a>
                                </Col>
                        )
                    }
                </Row>
                <Row>
                    {
                        this.thumbnails(this.props.pantPostPhotoList).map(
                            (item, index) =>
                                <Col xs={12} sm={6} key={item.get('id')}>
                                    <a href={item.get('image')} target="_blank">
                                        <img src={item.get('image')} className="img-thumbnail" alt="" />
                                    </a>
                                </Col>
                        )
                    }
                </Row>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/PhotoListComponent.jsx